import React from "react";

const Failed = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12L12 4M4 12L12 4"
        stroke="#CF222E"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M12 12L4 4L10.5806 10.5806"
        stroke="#CF222E"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Failed;
